import GlobalConfigEnvVars from "./globalConfigEnvVars.json";

// Environment variables to use in the browser.
// N.B. NextJS docs [1] say that env vars prefixed with NEXT_PUBLIC_ are available to the browser, but this feature
// is disabled if you have dotenv as a dependency [2]. Instead we go with the traditional global variable approach
// [1] https://nextjs.org/docs/basic-features/environment-variables#exposing-environment-variables-to-the-browser
// [2] https://github.com/vercel/next.js/blob/2ad351511ed6fb44161f42ae401a19b37cf131e3/packages/next/lib/load-env-config.ts#L27-L29

let globalConfig = {} as IGlobalConfig;

// Browser
if (typeof window !== "undefined" && (window as any).globalConfig != null) {
  globalConfig = (window as any).globalConfig;
}
// Server
else {
  const getEnvValue = (name: string) => {
    const value = process.env[`NEXT_PUBLIC_${name}`] ?? process.env[name];

    // These env vars are required for the frontend client to work properly, so fail fast if they're not defined.
    if (!value) {
      throw new Error(`Couldn't get value for required environment variable ${name}`);
    }

    return value;
  };

  globalConfig = {
    wwwBaseUrl: getEnvValue(GlobalConfigEnvVars.TRAVELLOCAL_WWW_URL),
    cdnBaseUrl: getEnvValue(GlobalConfigEnvVars.TRAVELLOCAL_CDN_BASEURL),
    apiBaseUrl: getEnvValue(GlobalConfigEnvVars.TRAVELLOCAL_API_URL),
    appBaseUrl: getEnvValue(GlobalConfigEnvVars.TRAVELLOCAL_APP_URL),
    uploadBaseUrl: getEnvValue(GlobalConfigEnvVars.TRAVELLOCAL_UPLOAD_URL),
    paymentBaseUrl: getEnvValue(GlobalConfigEnvVars.TRAVELLOCAL_PAYMENT_URL),
    hubspotPortalId: getEnvValue(GlobalConfigEnvVars.TRAVELLOCAL_HUBSPOT_PORTAL_ID),
  }
}

export default globalConfig;
